/* global axios */

import ApiClient from './ApiClient';

// Account-scoped API client. It deliberately uses Chatwoot's global axios
// instance, which carries the Bitrix SSO-created Chatwoot auth headers.
class Bitrix24PortalMembers extends ApiClient {
  constructor() {
    super('bitrix24_portal_members', { accountScoped: true });
  }

  sync(payload) {
    return axios.post(`${this.url}/sync`, payload);
  }
}

export default new Bitrix24PortalMembers();
